// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_i1-1";
export var quotedThread = "_i1-0";